import { h } from 'preact';

import MovieMediaEditor from 'components/editor/movies/movieMedia/movieMedia';

export default class FocusMovieMediaEditor extends MovieMediaEditor {
	renderOnesheet() {
		return super.renderOnesheet({ altPlaceholder: `Poster for ${this.movieTitle}` });
	}

	renderHeroImage() {
		return super.renderHeroImage({ altPlaceholder: `Hero image for ${this.movieTitle}`, focalPoint: true });
	}

	getSections() {
		return [
			{ label: 'Key art', content: [this.renderOnesheet()] },
			{ label: 'Hero', content: [this.renderHeroImage()] },
			{ label: 'YouTube trailers', note: 'Drag to reorder', content: this.renderTrailers() },
		].filter(Boolean);
	}
}